module.exports = __webpack_public_path__ + "static/media/alert-pending-icon.ed288e03.svg";